import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { ButtonSize } from './Base';
import './Buttons.scss';

type LinkPrimaryProps = Omit<LinkProps, 'className'> & {
    size?: ButtonSize;
    className?: string;
    children?: React.ReactNode;
};

/** Primary button styled as a React Router link. */
const LinkPrimary: React.FC<LinkPrimaryProps> = ({
    size = 'md',
    className,
    children,
    ...rest
}) => {
    const classes = [
        'btn',
        'btn--primary',
        size !== 'md' ? `btn--${size}` : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <Link className={classes} {...rest}>
            <span className="btn__label">{children}</span>
        </Link>
    );
};

export default LinkPrimary;
